import React from "react";
import { useDropzone } from "react-dropzone";
import { FaUpload, FaRegHandPaper } from "react-icons/fa";
import { ImSpinner2 } from "react-icons/im";

const CommonDropzone = ({ dropFile, isUploading }) => {
  const onDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file) dropFile(file);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div
      {...getRootProps()}
      className="w-full flex flex-col items-center justify-center border-2 border-dashed border-gray-400 p-6 rounded-lg text-center cursor-pointer"
    >
      <input {...getInputProps()} />

      {isUploading ? (
        <>
          <ImSpinner2 className="animate-spin text-blue-600 text-2xl" />
          <p className="mt-3 text-sm font-semibold">Uploading...</p>
        </>
      ) : isDragActive ? (
        <>
          <FaRegHandPaper className="text-[#181818] text-2xl" />
          <p className="mt-3 text-sm font-semibold">
            Release the file to upload!
          </p>
        </>
      ) : (
        <>
          <FaUpload className="text-[#181818] text-2xl" />
          <p className="mt-3 text-sm font-semibold">
            Drag & drop a file here, or click to select
          </p>
        </>
      )}
    </div>
  );
};

export default CommonDropzone;
